import React from 'react';
import { faNewspaper, faUsers } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { FeatureModalContainer } from '@components/NewFeatures/FeatureModalContainer';
import { SubSection } from '@components/NewFeatures/FeatureModalSubSection';
import { Button } from '@components/main-components/button/Button';
import { StandardModal } from '@components/main-components/modals/StandardModal';
import { useModal } from '@context/modal';
import { NAV_LINKS } from '@utils/constants';

const LEARN_MORE_LINK = 'https://help.sound.xyz/hc/en-us/articles/22302282427803/';

export function ChannelsFeatureModal() {
  const { closeCancelModal } = useModal();

  const body = (
    <FeatureModalContainer icon={faUsers}>
      <div className="flex w-full flex-col items-center justify-center gap-y-2 text-base800">
        <h2 className="font-title text-title-m font-medium sm:text-title-l ">
          Introducing Channels
        </h2>

        <p className="flex text-center font-base text-base-m sm:text-base-l ">
          A vibrant new way to discover and engage with
          <br />
          music communities on Sound
        </p>
      </div>

      <div className="mt-2 flex w-full flex-col gap-y-6">
        <SubSection icon={faNewspaper} title="Channel Pages">
          The heart of each community, where only owners and moderators can post initially, focusing
          on Sound songs or playlists.
        </SubSection>

        <SubSection icon={faUsers} title="Open to All">
          Anyone can join, view, and engage with posts, making channels inclusive spaces.
        </SubSection>
      </div>
    </FeatureModalContainer>
  );

  return (
    <StandardModal
      body={body}
      closeModal={closeCancelModal}
      callToAction={
        <div className="flex w-full justify-between gap-3 [&_a]:w-full">
          <Button variant="tertiary" size="L" label="Learn More" href={LEARN_MORE_LINK} fullWidth />

          <Button variant="primary" size="L" label="Explore" href={NAV_LINKS.Channels} fullWidth />
        </div>
      }
    />
  );
}
